// 검차 오더 상태 필 — 시안 A2 `.pill` 매핑 그대로. props: { status }
// 라벨은 앱 ARB(evalStatus*), 색은 v2 토큰. 알 수 없는 상태는 회색 + 원문 노출(날조 금지).
import React from 'react';
import { T, FONT, R } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';

// status → [키, 글자색, 배경, 테두리]
var MAP = {
  open: ['evalStatusOpen', T.muted, T.track, T.bd],
  taken: ['evalStatusTaken', T.accentPress, T.accentTint, T.accentBd],
  inspecting: ['evalStatusInspecting', T.warn, T.warnTint, T.warnBd],
  completed: ['evalStatusCompleted', T.ok, T.okTint, T.okBd],
  decided: ['evalStatusDecided', T.accentPress, T.accentTint, T.accentBd],
  rejected: ['evalStatusRejected', T.danger, T.dangerTint, T.dangerBd],
  cancelled: ['evalStatusCancelled', T.faint, T.track, T.bd]
};

var box = {
  display: 'inline-flex', alignItems: 'center', gap: 5, height: 22, padding: '0 9px',
  borderRadius: R.pill, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', flex: 'none', boxSizing: 'border-box'
};
var dot = { width: 5, height: 5, borderRadius: '50%', background: 'currentColor', flex: 'none' };

function SimpleStatusPill(props) {
  var t = useT();
  var m = MAP[props.status];
  var label = m ? t(m[0]) : (props.status || '-');
  var fg = m ? m[1] : T.muted;
  // border 는 단축만 — 변형 교체 시 키 집합이 달라지면 React 가 style 제거 경고를 낸다(v2 theme.js 규칙).
  var style = Object.assign({}, box, { color: fg, background: m ? m[2] : T.track, border: '1px solid ' + (m ? m[3] : T.bd), fontSize: FONT.badge + 0.5 });
  return (<span className="ss-pill" data-status={props.status || ''} style={style}>
    <i style={dot} />{label}
  </span>);
}

export default SimpleStatusPill;
